<template>
  <div >
    <router-view></router-view>
    <index-card :loading="loading">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push('/buildings/create')"
              center>
              <v-icon small left>mdi-plus</v-icon>Nova Obra
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <span class="headline white--text">
            Obras
          </span>
          <v-btn text icon @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="buildings-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :extra-filters-count="2"
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          >
            <template v-slot:extra-filters>
              <v-col cols="12" md="6">
                <SelectOneClient
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  @changeClient="handleChangeClient"
                ></SelectOneClient>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selected_status"
                  :items="statuses"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-list-status"
                  label="Status"
                />
              </v-col>
            </template>
          </filter-data>
        </div>
      </template>
      <template slot="data_table">
        <v-data-table :headers="headers" :items="buildings"
          class="elevation-4" :search="search" v-if="!loading" mobile-breakpoint="1">
          <template v-slot:item.attributes.status="{item}">
            <v-chip small :color="status_map[item.attributes.status].color">
              <v-avatar left>
                <v-icon small>{{status_map[item.attributes.status].icon}}</v-icon>
              </v-avatar>
              {{status_map[item.attributes.status].text}}
            </v-chip>
          </template>
          <template v-slot:item.actions="{item}">
            <div class="d-flex justify-center align-center">
              <v-btn @click="showBuilding(item)" small icon class="primary">
                <v-icon class="white--text" small>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </template>
    </index-card>
    
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index';

export default {
  name: 'Buildings',
  components:{
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    SelectOneClient: () => import("@/_backoffice/_financial/components/shared/SelectOneClient.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      loading: false,
      search: '',
      selected_client_id: null,
      selected_status: null,
      buildings: [],
      statuses:[
        {text:"Todos", value: null },
        {text:"Ativos", value: 10 },
        {text:"Desativados", value: 20 },
      ],
      local_filter: {
        client_id: null,
        status: null,
      },
      headers: [
        { text: 'Nome da obra', value: 'attributes.name', align: 'center' },
        { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
        { text: 'Endereço', value: 'attributes.full_address', align: 'center' },
        { text: 'Comentário', value: 'attributes.comment', align: 'center' },
        { text: 'Status', value: 'attributes.status', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' },
      ],
      status_map: {
        active: { color: 'success', icon:'mdi-check',text: 'Ativo'}, 
        disabled: { color: 'error', icon:'mdi-alert-circle',text: 'Inativo'}, 
      },
    }
  },
  methods: {
    getData(){
      this.getBuildings()
    },
    getBuildings(){
      this.loading = true
      Api.Building.index(this.local_filter).then((res)=>{
        this.buildings  = [...res.data.data]
      }).finally(()=>{
        this.loading = false
      })
    },
    handleChangeClient(client_id){
      this.selected_client_id = client_id
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
      this.local_filter = {
        ...this.local_filter,
        client_id: this.selected_client_id,
        status: this.selected_status,
      }
      this.getBuildings()
    },
    showBuilding(building){
      this.$router.push({name: "ShowBuilding", params:{ id: building.id }})
    },
    ...mapActions({
      
    })
  },
}
</script>

<style scoped>
.buildings-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.buildings-filters >>> .filter-data-card {
  width: 100%;
}
</style>